import React, { useMemo } from 'react';

import formatDate from 'helpers/formatDate';

import DoubleChart from 'components/data-visualization/DoubleChart/DoubleChart';
import AccordionMetadata from 'components/base/AccordionMetadata/AccordionMetadata';

import { IPosition } from './PlaylistTable';

export interface IPlaylistGraphProps {
  allPeriodKeys: Date[] | number[];
  color: string;
  entityId: string;
  fulfilled: { position: boolean; stream: boolean };
  hasNoData: { position: boolean; stream: boolean };
  isSmallScreen: boolean;
  onPeriodChange: (props?: any) => any;
  onTempPeriodChange: (props?: any) => any;
  pending: { position: boolean; stream: boolean };
  playlist: any;
  playlistData: IPosition[];
  selectedEntity: any;
  selectedTempEntity: any;
  streamsData: any;
  priorityPlaylistsShown?: boolean;
}

interface IPlaylistExpandedRow extends IPlaylistGraphProps {
  customerDisplayName: string;
}

const PlaylistExpandedRow: React.FC<IPlaylistExpandedRow> = (props) => {
  const {
    allPeriodKeys,
    color,
    customerDisplayName,
    entityId,
    fulfilled,
    hasNoData,
    isSmallScreen,
    onPeriodChange,
    onTempPeriodChange,
    pending,
    playlist,
    playlistData,
    selectedEntity,
    selectedTempEntity,
    streamsData,
  } = props;

  const { dateAdded, lastPeakDate, peak, totalDays } = playlist;

  const playlistMetadata = useMemo(
    () => [
      { name: 'Playlist', value: customerDisplayName },
      { name: 'Date added', value: formatDate(dateAdded, 'day-short') },
      { name: 'Total days', value: totalDays },
      { name: 'Peak', value: peak },
      { name: 'Last peak date', value: formatDate(lastPeakDate, 'day-short') },
    ],
    [customerDisplayName, dateAdded, lastPeakDate, peak, totalDays]
  );

  return (
    <>
      <AccordionMetadata data={playlistMetadata} />
      <DoubleChart
        allPeriodKeys={allPeriodKeys}
        color={color}
        entityId={entityId}
        fulfilled={fulfilled}
        hasNoData={hasNoData}
        isSmallScreen={isSmallScreen}
        onPeriodChange={onPeriodChange}
        onTempPeriodChange={onTempPeriodChange}
        pending={pending}
        positionsData={playlistData}
        selectedEntity={selectedEntity}
        selectedTempEntity={selectedTempEntity}
        streamsData={streamsData}
      />
    </>
  );
};

export default PlaylistExpandedRow;
